/* eslint-disable */
import { Button as AntdButton } from 'antd'
import React from 'react'
import styled, { css } from 'styled-components'
import { COLORS } from 'theme'

const BorderStyle = css`
  &:hover {
    border-color: ${COLORS.GREY_T_85};
  }
  &:focus {
    border-color: ${COLORS.GREY_T_85};
  }
`
const TextContainer = styled.div`
  margin-right: ${props => (props.marginRight ? '7px' : '')};
  margin-left: ${props => (props.icon ? '7px' : '')};
`
const dangerButtonStyles = css`
  background-color: ${COLORS.RED_S_100};
  border-color: ${COLORS.RED_S_100};
`
const secondaryButtonStyles = css`
  background-color: ${COLORS.PRIMARY_PURPLE};
  border-color: ${COLORS.PURPLE_T_80};
  color: '#FFFFFF';
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  &:hover {
    background-color: ${COLORS.PRIMARY_PURPLE};
    border-color: ${COLORS.PURPLE_T_80};
  }
  &:focus {
    background-color: ${COLORS.PRIMARY_PURPLE};
    border-color: ${COLORS.PURPLE_T_80};
  }
`
const greenButtonStyles = css`
  background-color: #01aa01ff;
  border-color: #01aa01ff;
  color: #FFFFFF;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0);
  &:hover {
    background-color: ##01aa01ff;
    border-color: ##01aa01ff;
    color: #FFFFFF;
  }
  &:focus {
    background-color: #01aa01ff;
    border-color: #01aa01ff;
    color: #FFFFFF;
  }
`
const defaultButtonStyles = css`
  color: #30475e;
`

const PlainButton = styled(AntdButton)`
  width: ${props => (props.width ? props.width : '')};
  height: ${props => (props.height ? props.height : '40px')};
  color: ${props => (props.type === 'secondary' ? COLORS.PRIMARY : '#FFFFFF')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${props => (props.radius ? props.radius : '8px')};
  justify-content: center;
  white-space: nowrap;
  padding: 0 16px;
  cursor: ${props => props?.disableCursor && 'not-allowed'};
  opacity: ${props => props?.disabled && '1'};
  pointer-events: ${props => (props?.disable ? 'none' : 'auto')};
  ${props => props.type === 'secondary' && secondaryButtonStyles}
  ${props => props.type === 'danger' && dangerButtonStyles};
  ${props => props.type === 'green' && greenButtonStyles};
  ${props => props.type === 'default' && defaultButtonStyles};
  ${props => props.dashed && 'border-style: dashed;'}
  ${BorderStyle}
`
const CircleButton = styled(AntdButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.dashed && 'border-style: dashed;'}
  background: ${props => (props.background ? props.background : '')};
  ${BorderStyle}
`

const Button = props => <AntdButton {...props} />

const Primary = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="primary">
    {icon}
    <TextContainer icon={!!icon}>{text}</TextContainer>
  </PlainButton>
)

const Secondary = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="secondary">
    {icon}
    <TextContainer icon={!!icon}>{text}</TextContainer>
  </PlainButton>
)

const Dashed = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="dashed">
    {icon}
    <TextContainer icon={icon}>{text}</TextContainer>
  </PlainButton>
)

const Danger = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="danger">
    {icon}
    <TextContainer icon>{text}</TextContainer>
  </PlainButton>
)

const Green = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="green">
    {icon}
    <TextContainer icon={!!icon}>{text}</TextContainer>
  </PlainButton>
)

const Default = ({ icon, text, onClick, ...rest }) => {
  return (
    <PlainButton onClick={onClick} {...rest} type="default">
      {icon}
      <TextContainer icon={icon}>{text}</TextContainer>
    </PlainButton>
  )
}

const Round = ({ icon, text, onClick, ...rest }) => {
  return (
    <PlainButton type="round" onClick={onClick} {...rest}>
      {icon}
      <TextContainer>{text}</TextContainer>
    </PlainButton>
  )
}

const Circle = ({ icon, onClick, ...rest }) => {
  return (
    <CircleButton type="circle" onClick={onClick} {...rest}>
      {icon}
    </CircleButton>
  )
}
const IconButton = ({ text, icon, ...props }) => (
  <PlainButton {...props} type="primary">
    <TextContainer marginRight={true} icon={!!icon}>
      {text}
    </TextContainer>
    {icon}
  </PlainButton>
)

Button.Primary = Primary
Button.Secondary = Secondary
Button.Dashed = Dashed
Button.Danger = Danger
Button.Green = Green
Button.Default = Default
Button.Round = Round
Button.Circle = Circle
Button.IconButton = IconButton

export default Button
